module.exports = __webpack_public_path__ + "static/EFFICIENT_RECRUITMENT_PROCESS-e7af72480581012e172d8e367a6bec7e.png";